import {
    POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID,
    POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID,
    RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID,
    RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID,
    RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID,
    RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID,
    RP_WEBHOOK_URL_PROPERTY_TYPE_ID,
    RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID
} from "@constants/webhook-constants";
import { FormattedAppliedProfile } from "@idw-types/data/applied-profile/applied-profile";
import { FormattedRpServiceConfigurationProperty } from "@idw-types/data/rp-service-configuration";
import { getRpServicePropertyValueOrAppliedProfilePropertyValue } from "@utils/applied-profile-util";

export const getWebhookConfigurationProperties = (
    properties: Array<FormattedRpServiceConfigurationProperty>,
    appliedProfiles: Array<FormattedAppliedProfile>
) => {

    const postToRPWebhookPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID);
    const postPiiToRPWebhookPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID);
    const rpWebhookFileNamePropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID);
    const rpWebhookUrlPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_URL_PROPERTY_TYPE_ID);
    const rpWebhookWrapperObjectPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID);
    const rpWebhookFlatEndpointPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID);
    const rpWebhookAuthTypePropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID);
    const rpWebhookAuthUserPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID);
    const rpWebhookAuthPassPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID);
    const rpWebhookTokenUrlPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID);
    const rpWebhookTokenClientIDPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID);
    const rpWebhookTokenClientSecretPropertyValue = getRpServicePropertyValueOrAppliedProfilePropertyValue(properties, appliedProfiles, RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID);
   
    return {
        postToRPWebhookPropertyValue,
        postPiiToRPWebhookPropertyValue,
        rpWebhookFileNamePropertyValue,
        rpWebhookUrlPropertyValue,
        rpWebhookWrapperObjectPropertyValue,
        rpWebhookFlatEndpointPropertyValue,
        rpWebhookAuthTypePropertyValue,
        rpWebhookAuthUserPropertyValue,
        rpWebhookAuthPassPropertyValue,
        rpWebhookTokenUrlPropertyValue,
        rpWebhookTokenClientIDPropertyValue,
        rpWebhookTokenClientSecretPropertyValue
    };
};

export const isPostToRpWebhookProperty = (propertyTypeId: string) => {
    return propertyTypeId === POST_TO_RP_WEBHOOK_PROPERTY_TYPE_ID;
};

export const isPostPiiToRpWebhookProperty = (propertyTypeId: string) => {
    return propertyTypeId === POST_PII_TO_RP_WEBHOOK_PROPERTY_TYPE_ID;
};

export const isRpWebhookFileNameProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_FILE_NAME_PROPERTY_TYPE_ID;
};

export const isRpWebhookUrlProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_URL_PROPERTY_TYPE_ID;
};

export const isRpWebhookWrapperObjectProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_WRAPPER_OBJECT_PROPERTY_TYPE_ID;
};

export const isRpWebhookFlatEndpointProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_FLAT_ENDPOINT_PROPERTY_TYPE_ID;
};

export const isRpWebhookAuthTypeProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_AUTH_TYPE_PROPERTY_TYPE_ID;
};

export const isRpWebhookAuthUserProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_AUTH_USER_PROPERTY_TYPE_ID;
};

export const isRpWebhookAuthPassProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_AUTH_PASS_PROPERTY_TYPE_ID;
};
export const isRpWebhookTokenUrlProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_TOKEN_URL_PROPERTY_TYPE_ID;
};

export const isRpWebhookTokenClientIDProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_TOKEN_OAUTH_ClIENT_ID_PROPERTY_TYPE_ID;
};

export const isRpWebhookTokenClientSecretProperty = (propertyTypeId: string) => {
    return propertyTypeId === RP_WEBHOOK_TOKEN_OAUTH_ClIENT_SECRET_PROPERTY_TYPE_ID;
};